<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="$router.currentRoute.path == '/' + role + '/customerManagement'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <v-row>
          <v-col>
            <h5 class="m-0 pt-1">مدیریت مشتری‌ها</h5>
          </v-col>
          <v-col>
            <v-btn style="float: left" @click="showNewCustomerDialog()">
              ثبت جدید +
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0 pe-4 ps-2 pt-4">
            <!-- <v-col cols="3" class="pb-0 mt-3">
              <v-select
                label="بر اساس"
                :items="searchOpt"
                v-model="sortBy"
                outlined
                dense
              ></v-select> -->
            <!-- </v-col> -->
            <v-col cols="6">
              <v-text-field
                v-model="userInput"
                placeholder="جستجو"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="text-left">
              <b-btn
                :disabled="userInput == ''"
                style="background-color: #aeb6bf !important"
                @click="delFilter()"
              >
                حذف فیلتر
              </b-btn>
            </v-col>
            <v-col class="text-left" cols="2">
              <v-btn
                :disabled="gettingReceipt || !customers.length"
                class="white--text darkRed-mainBtn"
                style="width: 135px; height: 35px"
                depressed
                @click="printReceipt()"
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >
            </v-col>
            <v-col cols="2">
              <vue-excel-xlsx
                :data="customers"
                :columns="excelFields"
                :file-name="`لیست مشتری‌ها`"
                :sheet-name="'لیست مشتری‌ها'"
                class="darkGreen-mainBtn mb-3 float-end"
                style="width: 135px; height: 35px"
                depressed
                :class="customers.length ? 'white--text' : 'disabled-excel'"
              >
                <v-icon
                  class="me-1"
                  :class="customers.length ? 'white--text' : ''"
                  >mdi-file-excel-outline</v-icon
                >خروجی اکسل
              </vue-excel-xlsx>
            </v-col>
          </v-row>
        </template>
        <b-table
          responsive
          show-empty
          :items="customers"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="userInput"
          id="customers-tabel"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>

          <template v-slot:cell(orderRatePercent)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}%
            </div>
          </template>
          <template v-slot:cell(orderPriceRatePercent)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}%
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn class="btn-success mr-1" @click="showOrders(data.item)"
                >درخواست‌ها</b-btn
              >
              <b-btn
                v-if="
                  role == 'Manager' ||
                  role == 'salesManager' ||
                  role == 'secretary'
                "
                class="mr-1"
                variant="primary"
                @click="showCustomerDialog(data.item.id)"
                >ویرایش</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="customers-tabel"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>

    <v-dialog v-model="customerDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش مشتری</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام مشتری"
              :loading="progress"
              v-model="customerName"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              dir="ltr"
              label="نام انگلیسی مشتری"
              :loading="progress"
              v-model="customerNameEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              dir="ltr"
              label="شماره اقتصادی"
              :loading="progress"
              v-model="economicalNumber"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              dir="ltr"
              label="شماره ثبت/ شماره ملی"
              :loading="progress"
              v-model="nationalNumber"
              type="number"
            ></v-text-field>
            <v-select
              label="رتبه مشتری"
              :items="customerPriorities"
              v-model="customerPriority"
              :loading="progress"
              :disabled="role != 'Manager' && role != 'salesManager'"
              outlined
              dense
            />
            <v-text-field
              outlined
              dense
              label="موبایل سازمانی (جهت دریافت پیامک‌های سیستمی)"
              :loading="progress"
              v-model="customerMobile"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="ایمیل سازمانی (جهت دریافت ایمیل‌های سیستمی)"
              :loading="progress"
              v-model="customerEmail"
            ></v-text-field>
            <v-autocomplete
              v-model.trim="stateId"
              :items="states"
              label=" استان"
              outlined
              dense
              item-text="name"
              item-value="id"
              no-data-text="موردی یافت نشد."
              hide-details
              :loading="stateLoading"
              class="mb-4"
              @input="getCities()"
            >
            </v-autocomplete>
            <v-text-field
              outlined
              dense
              label="شهرستان"
              :loading="progress"
              v-model="province"
            ></v-text-field>
            <v-autocomplete
              v-model.trim="cityId"
              :items="cities"
              label="شهر"
              outlined
              dense
              item-text="name"
              item-value="id"
              no-data-text="موردی یافت نشد."
              hide-details
              :loading="cityLoading"
              class="mb-4"
            >
            </v-autocomplete>
            <v-text-field
              v-model="address"
              outlined
              dense
              label="آدرس"
            ></v-text-field>
            <v-text-field
              v-model="postalCode"
              outlined
              dense
              label="کد پستی"
            ></v-text-field>
            <v-text-field
              v-model="phone"
              outlined
              dense
              label="تلفن یا نمابر"
              type="number"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="
              customerDialog = false;
              economicalNumber = '';
              nationalNumber = '';
              address = '';
              cityId = '';
              stateId = '';
              postalCode = '';
              phone = '';
            "
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="editCustomer()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newCustomerDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ثبت مشتری جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="نام مشتری"
              v-model="newCustomerName"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام انگلیسی مشتری*"
              dir="ltr"
              :loading="progress"
              v-model="newCustomerNameEn"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newCustomerDialog = false;     
              economicalNumber = '';
              nationalNumber = '';
              address = '';
              cityId = '';
              stateId = '';
              postalCode = '';
              phone = '';"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="addCustomer()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <br />
    <router-view></router-view>

    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">لیست مشتریان</h3>
      <b-table :items="customers" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../variables";
import router from "../router";

export default {
  data() {
    return {
      states: [],
      cities: [],
      stateLoading: false,
      cityLoading: false,
      stateId: "",
      cityId: "",
      province: "",
      address: "",
      economicalNumber: "",
      nationalNumber: "",
      postalCode: "",
      phone: "",
      guide: false,
      itemsLock: [],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "customerCode", sortable: true, label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        // { key: "type", label: "نوع مشتری" },
        { key: "customer_priority", sortable: true, label: "رتبه مشتری" },
        // { key: "mobile", label: "موبایل سازمانی" },
        // { key: "email", label: "ایمیل سازمانی" },
        {
          key: "orderRatePercent",
          sortable: true,
          label: "نرخ تبدیل استعلام به سفارش",
        },
        {
          key: "orderPriceRatePercent",
          sortable: true,
          label: "نرخ تبدیل مبلغ استعلام به سفارش",
        },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "customer_priority", label: "رتبه مشتری" },
        { key: "mobile", label: "موبایل سازمانی" },
        { key: "email", label: "ایمیل سازمانی" },
      ],
      customerPriorities: [
        { value: "VIP", text: "VIP" },
        { value: "معمولی", text: "معمولی" },
        { value: "لیست سیاه", text: "لیست سیاه" },
      ],
      customerName: "",
      customerNameEn: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      searchOpt: ["نام مشتری", "کد مشتری"],
      sortBy: "",
      userInput: "",
      currentPage: 1,
      currentPageLock: 1,
      perPage: 10,
      TotalRows: 1,
      totalRowsLock: 0,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      filter: null,
      role: "",
      customers: [],
      selected: "",
      newCustomerDialog: false,
      newCustomerName: "",
      newCustomerNameEn: "",
      progress: false,
      printInvoice: {},
      gettingReceipt: false,
      customer: "",
      excelFields: [
        { field: "customerCode", label: "کد مشتری" },
        { field: "name", label: "نام مشتری" },
        { field: "customer_priority", label: "رتبه مشتری" },
        { field: "mobile", label: "موبایل سازمانی" },
        { field: "email", label: "ایمیل سازمانی" },
      ],
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    delFilter() {
      // this.sortBy = "";
      this.userInput = "";
      // this.isBusy = true;
      // this.showCustomers();
    },

    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },

    showNewCustomerDialog() {
      this.newCustomerDialog = true;
    },
    addCustomer() {
      this.newCustomerDialog = false;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customer/new",
        {
          name: this.newCustomerName,
          nameEn: this.newCustomerNameEn,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newCustomerName = "";
            this.newCustomerNameEn = "";
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy = false;
        });
    },
    editCustomer() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customer/edit",
        {
          customerId: this.selected,
          name: this.customerName,
          nameEn: this.customerNameEn,
          customer_priority: this.customerPriority,
          mobile: this.customerMobile,
          email: this.customerEmail,
          cityId: this.cityId,
          province: this.province,
          stateId: this.stateId,
          economicalCode: this.economicalNumber,
          nationalId: this.nationalNumber,
          address: this.address,
          tel: this.phone,
          postalCode: this.postalCode,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.isBusy = true;
            this.customerName = "";
            this.customerNameEn = "";
            this.customerPriority = "";
            this.customerEmail = "";
            this.customerMobile = "";
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customer/getAbstractInfo",
        {
          customerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.progress = false;
          if (res.status == 200) {
            this.customerName = res.data.name;
            this.customerNameEn = res.data.nameEn;
            this.customerPriority = res.data.customer_priority;
            this.customerEmail = res.data.email;
            this.customerMobile = res.data.mobile;
            this.progress = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getState() {
      this.stateLoading = true;
      Axios
        .get(this.baseUrl + '/ppkpms/requirements/allStates', {
          headers: {
            Authorization: 'Bearer: ' + localStorage.getItem('token'),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.stateLoading = false;
            this.states = res.data;
          }
        })
        .catch((err) => {
          this.stateLoading = false;
          console.log(err);
        });
    },
    getCities() {
      this.cityLoading = true;
      this.cityId = '';
      if (this.stateId) {
        Axios
          .get(this.baseUrl + '/ppkpms/requirements/citiesOfState/' + this.stateId, {
            headers: {
              Authorization: 'Bearer: ' + localStorage.getItem('token'),
            },
          })
          .then((res) => {
            if (res.status == 200) {
              this.cityLoading = false;
              this.cities = res.data;
              this.reactivity = !this.reactivity;
            }
          })
          .catch((err) => {
            this.cityLoading = false;
            console.log(err);
          });
      }
    },
    showCustomerDialog(customer) {
      this.customerDialog = true;
      this.customerName = "";
      this.selected = customer;
      this.getCustomerInfo();
    },
    searchCustomer() {
      if (this.sortBy == "نام مشتری") {
        Axios.post(
          this.baseUrl + "/ppkpms/customers/getByName",
          {
            name: this.userInput,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.isBusy = false;
            if (res.status == 200) {
              this.customers = res.data;
              this.TotalRows = this.customers.length;
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.isBusy = false;
          });
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/customers/getByCode",
          {
            code: this.userInput,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.isBusy = false;
            if (res.status == 200) {
              this.customers = res.data;
              this.TotalRows = this.customers.length;
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.isBusy = false;
          });
      }
    },
    showOrders(item) {
      this.$router.push("/" + this.role + "/customerProfile/" + item.id);
      localStorage.setItem("customer", item.name);
    },
    lockCustomer(item) {
      this.selectedCustomer = item;
      this.showModalLock();
    },
    showModalLock() {
      this.$refs["modalLock"].show();
    },
    closeModalLock() {
      this.$refs["modalLock"].hide();
    },
    showCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
            this.TotalRows = this.customers.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
  },

  mounted() {
    this.showCustomers();
    this. getState();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
